<table style="width: 100%; height: 100%; color:#fff; background-color:#94badd;">
	<tr *ngIf="isPrior">
		<td [ngStyle]="{'vertical-align':'top', 'background-repeat':'no-repeat', 'background-size':'cover', 'background-image':'url(assets/images/anonymousUser/AnonymousEmailBefore.png)','height':showMinimize?'':'300px'}">
			<div class="float-end" style="padding:10px;">
				<span class="jmCloseBtn" (click)="cancel($event)"></span>
			</div>
		</td>
	</tr>
	<tr *ngIf="!isPrior">
		<td [ngStyle]="{'vertical-align':'top', 'background-repeat':'no-repeat', 'background-size':'cover', 'background-image':'url(assets/images/anonymousUser/AnonymousEmailAfter.png)', 'height':showMinimize?'':'300px'}">
			<div class="float-end" style="padding:10px;">
				<span class="jmCloseBtn" (click)="cancel($event)"></span>
			</div>
		</td>
	</tr>
	<tr>
		<td style="height:400px; padding:15px; vertical-align:top; text-align:center;">
			<div class="jmLoginBox">
				<div class="jmLoginTitle" style=" font-size:20px;">
					<div *ngIf="isPrior">
						<div>
							Welcome to Journeys Map’s {{requestFrom}} survey! Take a few minutes to see how your {{requestFrom}} can connect you with the career of your dreams.
						</div>
						<div style="margin-top:15px;">
							Enter your email below to save your results to your free Journeys Map account!
						</div>
					</div>
					<div *ngIf="!isPrior">
						Wow these results are incredible! Enter your email to save them!
					</div>
				</div>
				<div class="jmLoginInput">
					<div style="position: relative;">
						<input [(ngModel)]="newAnonymousUser.Email" id="txtEmail" type="text" autocomplete="off" [ngClass]="newAnonymousUser.EmailStatus==null?'jmUnderline':newAnonymousUser.EmailStatus?'jmUnderlineOk':'jmUnderlineError'" maxlength="50" placeholder="Your Email" (keyup)="checkUser($event)" />
						<i class="fas fa-check-circle jmLoginStatus" style="color: #1D81F8;" *ngIf="newAnonymousUser.EmailStatus===true"></i>
						<i class="far fa-times-circle jmLoginStatus" style="color: red;" *ngIf="newAnonymousUser.EmailStatus===false"></i>
					</div>
					<div style="position: relative;">
						If you don't have an email address, don't feel bad, just <a href="javascript:void(0);" (click)="cancel($event)">skip</a> ahead!
					</div>
				</div>
				<div class="jmLoginAction">
					<div *ngIf="!processing"><button class="btn btn-info" (click)="checkUser($event)" style="width: 100px;" [ngClass]="newAnonymousUser.Email !== ''?'':'disabled'">Next</button></div>
					<div *ngIf="processing" style="font-size: 16px;"><i class="jmWidgetLoadingIcon20" style="filter: brightness(1.5);"></i></div>
				</div>
				<div *ngIf="!processing">
					<div *ngIf="errorType===1">
						Oops! Something is funky. Please enter a valid email address.
					</div>
					<div *ngIf="errorType===2">
						Fail to save. Please retry.
					</div>
				</div>
			</div>
		</td>
	</tr>
</table>

